export enum WhitelabelEnum {
  CEDRO = 1,
  PI = 2,
  RB = 3,
  FASTTRADE = 4,
  FAST = 5,
  DAYCOVAL = 6,
  FC = 7,
  TRINUS = 8,
  EMPIRICUS = 9,
  RANKING = 10,
  AMARIL = 11,
  GUIDE = 12
}
